export class ReferenceDataSwitchCaseStatus {
  public static readonly IllustrationIssued = 'IllustrationIssued';
  public static readonly IllustrationRequested = 'IllustrationRequested';
  public static readonly IllustrationDownloadFailed = 'IllustrationDownloadFailed';
  public static readonly IllustrationDownloadPending = 'IllustrationDownloadPending';
  public static readonly IllustrationManualProcessing = 'IllustrationManualProcessing';
  public static readonly IllustrationNotProceeding = 'IllustrationNotProceeding';
  public static readonly SwitchInProgress = 'InProgress';
  public static readonly SwitchCompleted = 'SwitchCompleted';
  public static readonly SwitchDownloadPending = 'SwitchDownloadPending';
  public static readonly SwitchDownloadFailed = 'SwitchDownloadFailed';
  public static readonly SwitchManualProcessing = 'RTRN2DAT';
  public static readonly SwitchConfirmed = 'SwitchConfirmed';
  public static readonly SwitchNotProceeding = 'SwitchNotProceeding';
  public static readonly SwitchDropped = 'DROPPED';
  public static readonly SwitchDeclined = 'DECLINED';
  public static readonly SwitchRequested = 'SwitchRequested';
  public static readonly SwitchOfferIssuedPostal = 'MANOFFER';
  public static readonly SwitchOfferIssuedOnline = 'OFFPRINT';
  public static readonly SwitchOfferIssuedForcedPostal = 'FORPOST';
  public static readonly SwitchOfferAccepted = 'OfferAccepted';
  public static readonly SwitchOfferExpired = 'OfferExpired';

  public static readonly SwitchCaseStatusesNotProceeding = [
    this.SwitchNotProceeding,
    this.SwitchDeclined,
    this.SwitchDropped,
    this.SwitchOfferExpired
  ];
}
